import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { IState } from 'shared/interfaces/state.interface';
import { TCurrentTransaction } from 'shared/types';
import { initialStore } from '../initial-store';

// Slices

const transactionsSlice = createSlice({
  name: 'transactions',
  initialState: initialStore.transactions,
  reducers: {
    getTransactionsData: (state) => {
      if (!state.isLoading) {
        state.isLoading = true;
      }
    },
    getCurrentTransaction: (
      state,
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      data: PayloadAction<TCurrentTransaction>
    ) => {
      if (!state.isLoading) {
        state.isLoading = true;
      }
    },
    setCurrentTransaction: (state, { payload }) => {
      state.isLoading = false;
      state.currentTransaction.data = payload.currentTransaction;
      state.currentTransaction.paymentMethod = payload.paymentMethod;
    },
    setTransactionsData: (state, { payload }) => {
      state.isLoading = false;
      state.allTransactions = payload.transactions;
      state.countTransactions = payload.transactionsCount;
    },
    getTransactionsFail: (state) => {
      state.isLoading = false;
    }
  }
});

export const {
  getTransactionsData,
  getCurrentTransaction,
  getTransactionsFail,
  setTransactionsData,
  setCurrentTransaction
} = transactionsSlice.actions;

export const { reducer } = transactionsSlice;

// Selectors
export const getAllTransactionsSelector = (state: IState) =>
  state && state.transactions.allTransactions;

export const getOneTransactionsSelector = (state: IState) =>
  state && state.transactions.currentTransaction;

export const getTransactionsCountSelector = (state: IState) =>
  state && state.transactions.countTransactions;

export const getTransactionsLoadingSelector = (state: IState) =>
  state && state.transactions.isLoading;
